var BufferFormatter = require('bufferformatter');
var MemberView = require('memberview');


var ChannelMembersView = Backbone.View.extend({
    tagName: 'ul',
    className: 'memberList',
    initialize: function () {
        this.model.bind('remove', this.remove, this);
        this.model.bind('preinit', this.render, this);
        this.formatter = new BufferFormatter(this.model);
    },
    makeSegmentedList: function (collection, categoryName) {
        var category = $('<li class="category">').addClass(collection.getClass());
        this.lists[categoryName] = category;

        var heading = $('<h2>').text(collection.getModeTitle());
        
        var headingExtras = $('<span class="memberExtras">');
        
        var modeSymbol = collection.getModeSymbol();
        if (!collection.isMember() && modeSymbol) {
            modeSymbol = $('<span class="mode_prefix mode_symbol">').addClass('mode_' + collection.getModeCategory()).text(modeSymbol);
            var modePill = $('<span class="mode_prefix mode_pill">').addClass('mode_' + collection.getModeCategory()).text('•');
            headingExtras.append(modeSymbol);
            headingExtras.append(modePill);
        }
        
        headingExtras.append($('<span class="memberCount">'));
        
        heading.append(headingExtras);
        category.append(heading);

        var list = $('<ul class="categoryMemberList categoryMemberList--present">');
        this.renderMembers(list, collection);
        category.append(list);

        var listAway;
        if (this.model.connection.isSlackOAuth()) {
            listAway = $('<ul class="categoryMemberList categoryMemberList--away">');
            this.renderMembers(listAway, collection);
            category.append(listAway);
        }

        this.listenTo(collection, 'add', function (member) {
            this.renderMember(list, collection, member);
            if (listAway) {
                this.renderMember(listAway, collection, member);
            }
        });
        this.listenTo(collection, 'remove', function () {
            this.renderList(collection);
        });
        if (this.model.connection.isSlackOAuth()) {
            this.listenTo(collection, 'change:away', function () {
                this.renderList(collection);
            });
        }
        this.listenTo(collection, 'reset', function () {
            this.renderMembers(list, collection);
            if (listAway) {
                this.renderMembers(listAway, collection);
            }
            this.renderList(collection);
        });
        
        this.$el.append(category);
    },
    render: function (members) {
        this.$el.empty();
        this.stopListening();
        this.lists = {};
        _.each(this.model.members.lists, function (collection, categoryName) {
            this.makeSegmentedList(collection, categoryName);
        }, this);
        
        return this;
    },
    renderMembers: function (list, collection) {
        list.empty();
        collection.sort();
        var els = collection.map(function (member) {
            var memberView = new MemberView({
                model: member,
                formatter: this.formatter
            });
            return memberView.render().el;
        }, this);
        list.append.apply(list, els);
        this.renderList(collection);
    },
    renderMember: function (list, collection, member) {
        var memberView = new MemberView({
            model: member,
            formatter: this.formatter
        });
        
        // Insert in the correct position
        var selector = memberView.tagName + '.' + memberView.className.split(' ').join('.');
        var existing = list.find(selector);
        var index = collection.indexOf(member);
        var el = memberView.render().el;
        if (index == existing.length) {
            list.append(el);
        } else {
            existing.eq(collection.indexOf(member)).before(el);
        }
        
        this.renderList(collection);
    },
    renderList: function (collection) {
        var size = collection.length;
        // if (this.model.connection.isSlackOAuth()) {
        //     size = collection.filter(function (m) {
        //         return !m.isAway();
        //     }).length;
        // }
        var segment = this.lists[collection.getModeCategory()];
        segment.toggle(!!size);
        segment.find('h2 span.memberCount').text(size);
    }
});


module.exports = ChannelMembersView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/channelmembersview.js
// module id = KEE7
// module chunks = 1